import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import type { NodeSpec } from './NodeSpec';

export const materialAssemblyUiNodeSpec: NodeSpec<NodeCfg<'materialAssembly'>> = {
    cfg: () => ({
        kind: 'materialAssembly',
        id: getUID(),
        controlValues: {},
    }),
    controls: () => ({}),
    requiredSockets: [ 'trigger', 'parentMaterial', 'componentMaterialId' ],
    inputs: () => ({
        trigger: { socket: 'event', label: 'Trigger' },
        parentMaterial: { socket: 'string', label: 'Assembly Material ID' },
        componentMaterialId: { socket: 'string', label: 'Component Material ID' },
    }),
    nodeCategory: 'material',
    kindLabel: 'Material Assembly',
    outputs: () => ({
        good: { socket: 'event', label: 'Good' },
        bad: { socket: 'event', label: 'Bad' },
    }),
    validator: () => true,
};
